/* RESPONSIBLE TEAM: team-inbox */
import Route from '@ember/routing/route';
import type NewConversationController from 'embercom/controllers/inbox/workspace/inbox/new-conversation';

export default class extends Route {
  queryParams = { recipient: {}, ticketTypeId: {}, forwardedPartId: {} };

  buildRouteInfoMetadata() {
    return {
      responsibleTeam: 'team-inbox',
    };
  }

  resetController(controller: NewConversationController, isExiting: boolean) {
    if (isExiting) {
      controller.recipient = undefined;
      controller.ticketTypeId = undefined;
      controller.forwardedPartId = undefined;
    }
  }
}
